import { render } from "./403.vue?vue&type=template&id=5d9ebfd8&scoped=true"
const script = {}

import "./403.css?vue&type=style&index=0&id=5d9ebfd8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9ebfd8"]])

export default __exports__